import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import { COMMON } from "@store/theme/design";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
import { css } from "styled-components";

type BannerSpacingProperty = "margin" | "padding";
type BannerSpacingDirection = "horizontal" | "vertical";

export const bannerSpacingStyles = (property: BannerSpacingProperty, direction?: BannerSpacingDirection) => {
    let properties = [`${property}`];

    if (direction === "horizontal") {
        properties = [`${property}-right`, `${property}-left`];
    } else if (direction === "vertical") {
        properties = [`${property}-top`, `${property}-bottom`];
    }

    return css`
        ${props =>
            breakpointValuesMediaQueries(
                props.theme,
                [{ values: [COMMON.spacing.side[0], null, null, null, "30px"], properties }],
                mediaOptions.min,
            )}
    `;
};
